import links from "../../../const/links";

export default {
  match_admin: [
    { url: "/admin/check", name: "가입자 확인" },
    {
      url: "/admin/list/news",
      url2: "/admin/list/youtube",
      name: "IP담보대출",
    },
    // { url: '/admin/list/video', name: '동영상' },
    // {
    //   url: "/admin/service",
    //   redirectURL: "/admin/service/list",
    //   name: "서비스",
    // },
    {
      url: "/admin/manage",
      redirectURL: "/admin/manage/list",
      name: "관리메뉴",
    },
    // { url: '/admin/list/document', name: '문서' },
    // { url: "/admin/list/edu", name: "특허교육자료" },
    {
      url: "/admin/community",
      redirectURL: "/admin/community/list",
      name: "커뮤니티",
    },
    { url: "/admin/invest", name: "특허투자자" },
    { url: "/admin/account", name: "계정생성" },
    { url: "/admin/maintenance", name: "유지보수관리" },
    {
      url: "/admin/annual",
      url2: "/annual/",
      name: "연차료관리",
    },
    // { 기존 매출관리 페이지 삭제 예정 }
    // {
    //   url: "/admin/annual/sales",
    //   redirectURL: "/admin/annual/sales",
    //   name: "매출관리",
    // },
    {
      url: "/admin/annual/sales/paid",
      redirectURL: "/admin/annual/sales/paid",
      name: "매출관리",
    },
  ],

  match_agent: [
    { url: "/invention/", redirectURL: "/invention/list", name: "직무발명 신고" },
    { url: "/patent/", redirectURL: "/patent/list", name: "특허" },
    { url: "/tradeMark/", redirectURL: "/tradeMark/list", name: "상표" },
    { url: "/design/", redirectURL: "/design/list", name: "디자인" },
    { url: "/cost/", redirectURL: "/cost/list", name: "비용관리" },
  ],

  match_inventor: [
    { url: "/invention/", redirectURL: "/invention/list", name: "직무발명 신고" },
    { url: "/patent/", redirectURL: "/patent/list", name: "특허" },
    { url: "/tradeMark/", redirectURL: "/tradeMark/list", name: "상표" },
    { url: "/design/", redirectURL: "/design/list", name: "디자인" },
  ],

  match_intro_ipnow: [{ url: "/people", name: "People" }],

  match_intro_login: [
    { url: "/", name: "HOME" },
    { url: links.taskManage, name: "정부사업 찾기" },
    { url: links.marketInfo, name: "시장 정보" },
    { url: "/intro/page", name: "2023 부처별 통합공고" },
    { url: "/intro/page2", name: "2023 정부지원사업" },
    {
      url: links.exposition,
      name: "정부사업 주요 소식",
      child_Tab: [
        {
          url: links.exposition,
          name: "행사정보",
        },
        {
          url: links.businessDescription,
          name: "사업설명회 영상",
        },
        {
          url: links.govSupport,
          name: "정부지원 정책",
        },
      ],
    },
  ],
  match_intro: [
    { url: links.taskManage, name: "정부사업 찾기" },
    { url: links.marketInfo, name: "시장 정보" },
    { url: "/intro/page", name: "2023 부처별 통합공고" },
    { url: "/intro/page2", name: "2023 정부지원사업" },
    {
      url: links.exposition,
      name: "정부사업 주요 소식",
      child_Tab: [
        {
          url: links.exposition,
          name: "행사정보",
        },
        {
          url: links.businessDescription,
          name: "사업설명회 영상",
        },
        {
          url: links.govSupport,
          name: "정부지원 정책",
        },
      ],
    },
  ],

  match_openMarket: [{ url: "/trade/list", name: "상표거래" }],

  match_findx: [
    { url: links.taskManage, name: "사업 리스트" },
    // { url: '/consortium/list', name: '사업 파트너 기업' },
    { url: links.marketInfo, name: "시장 정보 보기" },
    { url: "/docTrade/list", name: "제안서 샘플마켓" },
    { url: "/exposition/list", name: "교육·행사·경진" },
    { url: "/businessDescription/list", name: "사업 설명회" },
    { url: "/govSupport/list", name: "정부지원 정책알림" },
    { url: "/consultCom/list", name: "컨설팅 기업" },
  ],

  match_ip_service: [
    { url: "/invention/", redirectURL: "/invention/list", name: "직무발명 신고" },
    { url: "/patent/", redirectURL: "/patent/list", name: "특허" },
    { url: "/tradeMark/", redirectURL: "/tradeMark/list", name: "상표" },
    { url: "/design/", redirectURL: "/design/list", name: "디자인" },
    { url: "/deadline/", redirectURL: "/deadline/list", name: "기한관리" },
    { url: "/annual/", redirectURL: "/annual/graph", name: "연차료관리" },
    // {
    //   url: "/kautum/statistic",
    //   redirectURL: "/kautum/statistic",
    //   name: "심플 통계",
    // },
    // { url: '/application/', redirectURL: '/application/list', name: '특허 활용 정보', activeTab: 3},
    // { url: '/trade/', redirectURL: '/trade/list', name: '상표거래', activeTab: 4},
  ],

  /** 로그인 고객사 메뉴에서 연차료관리 오른쪽에 삽입 */
  cost_manage: {
    url: "/cost/",
    redirectURL: "/cost/list",
    name: "비용관리",
  },
  /** 출연연 로그인 시에만 메뉴에 삽입 */
  invention_review: {
    url: "/invention/reviews",
    redirectURL: "/invention/reviews/evaluations",
    name: "직무발명 심의",
  },
  /** statistics_service === "true" 일 때만 삽입 */
  patent_statistic: {
    url: "/dueDi/dashboard",
    redirectURL: "/dueDi/dashboard",
    name: "특허 통계 (자산실사)",
  },
  /** simple_statistics_service === "true" 일 때만 삽입 */
  simple_statistic: {
    url: "/kautum/statistic",
    redirectURL: "/kautum/statistic",
    name: "심플 통계",
  },
  /** transfer_statistics_service === "true" 일 때만 삽입 */
  tech_transfer: {
    url: "/tech/transfer",
    redirectURL: "/tech/transfer",
    name: "기술이전관리",
  },
  /** "true" / true / 1 모두 활성으로 본다 */
  isServiceEnabled(value) {
    if (value === true || value === 1) return true;
    const s = String(value ?? "")
      .trim()
      .toLowerCase();
    return s === "true" || s === "1";
  },

  /**
   * 회사 서비스 메뉴 추가.
   * rank 2(발명자)는 flags를 비워 호출해 통계·기술이전을 넣지 않는다.
   */
  appendServiceMenus(items, flags = {}) {
    return [
      ...items,
      this.isServiceEnabled(flags.statistic) && this.patent_statistic,
      this.isServiceEnabled(flags.simple) && this.simple_statistic,
      this.isServiceEnabled(flags.transfer) && this.tech_transfer,
    ].filter(Boolean);
  },

  /**
   * 고객사(경영진·관리자·슈퍼) 로그인 메뉴.
   * options: { hideAnnual, showInventionReview, statistic, simple, transfer }
   */
  buildCompanyMenus(options = {}) {
    const {
      hideAnnual = false,
      showInventionReview = false,
      statistic,
      simple,
      transfer,
    } = options;
    const base = this.match_ip_service.flatMap((item) => {
      if (item.url === "/annual/" && hideAnnual) {
        return [this.cost_manage];
      }
      if (item.url === "/annual/") return [item, this.cost_manage];
      if (item.url === "/invention/" && showInventionReview) {
        return [item, this.invention_review];
      }
      return [item];
    });
    return this.appendServiceMenus(base, { statistic, simple, transfer });
  },

  /** 발명자(rank 2) 메뉴 — 통계·기술이전·연차·비용 비노출 */
  buildInventorMenus(options = {}) {
    const { showInventionReview = false } = options;
    return this.match_inventor.flatMap((item) => {
      if (item.url === "/invention/" && showInventionReview) {
        return [item, this.invention_review];
      }
      return [item];
    });
  },

  /** 대리인 메뉴 */
  buildAgentMenus() {
    return [...this.match_agent];
  },

  /** 관리자 메뉴 */
  buildAdminMenus() {
    return [...this.match_admin];
  },

  match_groupware: [
    { url: "/renewal/groupware", name: "그룹웨어 HOME" },
    { url: "/renewal/groupware", name: "메일" },
    { url: "/renewal/groupware", name: "업무공유" },
    { url: "/renewal/groupware", name: "전자결재" },
    { url: "/renewal/groupware", name: "오피스폼" },
  ],
};
